// extracted by mini-css-extract-plugin
export var blockNftStaking = "BlockNftStaking_blockNftStaking__CLS8Q";
export var rotate = "BlockNftStaking_rotate__8LzoW";
export var dotty = "BlockNftStaking_dotty__aUuie";